<template>
  <div class="animated fadeIn">
    <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:115px;margin-bottom:12px;margin-top:10px;">
      <b-row style="min-width: 1200px;">
        <b-col sm="3">
          <div style="margin-top:-7px;">
            <span class="card-title wise-card-header">리치 커브 시뮬레이션</span>
          </div>
          <div class="wise-small-header">Reach Curve Simulation</div>
        </b-col>
        <b-col sm="9" class="brief">
          <b-row >
            <b-col sm="12" style="padding-bottom:10px">
              <span class="card-title wise-card-title">1. 캠페인 기본 정보 입력</span>
              <span class="small text-muted wise-card-subtitle"> 캠페인의 기본정보를 입력하세요</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="5">
              <div class="input-bottom-line">
                <b-row>
                  <b-col sm="2" class="wise-small-header wise-small-header2" style="">타이틀</b-col>
                  <b-col sm="10" style="padding-left:0px">
                    <b-form-input class="no-border" :class="{error: errors.has('campaignTitle')}" name="campaignTitle" v-validate="'required|min:2'" v-model="formData.campaignTitle" type="text" placeholder="캠페인 타이틀을 입력하세요 "></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="3">
              <div class="input-bottom-line" v-on:click="advertigerModal = true">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">광고주</b-col>
                  <b-col sm="8" style="padding-left:0px;">
                    <input class="form-control no-border" :class="{error: errors.has('advertiger')}" name="advertiger" v-validate="'required|min:2'" v-model="advertigerName" type="text" placeholder="광고주를 선택하세요" v-on:focus="advertigerModal = true"></input>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col sm="3">
              <div class="input-bottom-line" v-on:click="agencyModal = true">
                <b-row>
                  <b-col sm="4" class="wise-small-header wise-small-header2">대행사</b-col>
                  <b-col sm="8" style="padding-left:0px;">
                    <input class="form-control no-border" :class="{error: errors.has('agency')}" name="agency" v-validate="'required|min:2'" v-model="agencyName" type="text" placeholder="대행사를 선택하세요" v-on:focus="agencyModal = true"></input>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:300px;margin-bottom:12px;">
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:35px;">
          <b-col sm="12">
            <span class="card-title wise-card-title">2. 매체 계획(미디어 믹스) 입력 </span>
            <span class="float-right" style="padding-right:20px;">
              <b-button block variant="outline-primary" class="btn-pill" @click="addMedia();changeRootIndex(500)">
                <span style="font-weight:900;">매체 추가</span>
              </b-button>
            </span>
          </b-col>
        </b-row>
        <b-row style="padding-bottom:10px; text-align:center;" class="wise-small-header">
          <b-col sm="5">
            <div>
              <b-row>
                <b-col sm="3">광고소재</b-col>
                <b-col sm="2">미디어</b-col>
                <b-col sm="3">채널</b-col>
                <b-col sm="4">비히클</b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="2">CPM/CPRP</b-col>
          <b-col sm="1">타겟</b-col>
          <b-col sm="4">
            <b-row>
              <b-col sm="4">금액범위</b-col>
              <b-col sm="4">단위</b-col>
              <b-col sm="1"></b-col>
              <b-col sm="1"></b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="panelScrollBar" style="overflow-y:auto;overflow-x:hidden;">
          <div style="max-height:160px;">
            <component v-bind:mediaList="formData.mediaList"
            v-bind:flagRootIndex="flagRootIndex"
            v-on:changeRootIndex="changeRootIndex($event)"
            ref="mediaListRef" v-for="item in componentsMediaList"
            v-bind:key="item.id" :is="item">
            </component>
          </div>
        </div>
      </div>
    </b-card>
    <b-modal title="광고주 검색" size="lg" v-model="advertigerModal" @ok="advertigerModal = false">
      <div>
        <b-input-group>
          <input v-model="search_avdt_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="광고주 검색" @keyup.enter="findAdvertiger()"></input>
          <b-input-group-append>
            <b-button style="margin-left:5px;" variant="primary" @click="findAdvertiger()"><i class="fa fa-search"></i> 검색</b-button>
            <b-button style="margin-left:5px;" variant="secondary" @click="advertigerModal = false">취소</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="">
        <br />
        <b>위 검색어에 대한 결과 총 {{advertigerList.length}}건 검색 완료</b>
        <br />
        <br />
      </div>
      <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
        <div style="max-height:200px;">
          <b-button v-for="item in advertigerList" v-bind:key="item.advt_CD" variant="outline-primary" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <div class="">
          <br />
          <b>최근 검색된 광고주</b>
          <br />
          <br />
        </div>
        <div class="searched-block">
          <b-button v-for="item in local_advertigerList" v-bind:key="item.advt_CD" variant="outline-success" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal title="대행사 검색" size="lg" v-model="agencyModal" @ok="agencyModal = false">
      <div>
        <b-input-group>
          <input v-model="search_agc_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="대행사 검색" @keyup.enter="findAgency()"></input>
          <b-input-group-append>
            <b-button style="margin-left:5px;" variant="primary" @click="findAgency()"><i class="fa fa-search"></i> 검색</b-button>
            <b-button style="margin-left:5px;" variant="secondary" @click="agencyModal = false">취소</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="">
        <br />
        <b>위 검색어에 대한 결과 총 {{agencyList.length}}건 검색 완료</b>
        <br />
        <br />
      </div>
      <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
        <div style="max-height:200px;">
          <b-button v-for="item in agencyList" v-bind:key="item.agc_CD" variant="outline-primary" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <div class="">
          <br />
          <b>최근 검색된 대행사</b>
          <br />
          <br />
        </div>
        <div class="searched-block">
          <b-button v-for="item in local_agencyList" v-bind:key="item.agc_CD" variant="outline-success" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
        </div>
      </div>
    </b-modal>
    <div style="padding-bottom:10px;">
      <div style="background-color:white; border-left: 2px solid #428bca;">
        <b-button block variant="outline-primary" style="border:1px solid #c2cfd6;border-left: 0px;" v-on:click="goResult()">
          <span style="font-weight:900;">GO 리치 커브 시뮬레이션 → </span>
        </b-button>
      </div>
    </div>
    <b-card style="height:120px" class="bs-callout bs-callout-primary panelScrollBar">
      <div style="min-width: 1200px;font-weight:bold">
        <!-- <b-row style="padding-bottom:35px;"> -->
          * 제시되는 결과는 닐슨 3-screen 싱글소스 패널 데이터를 중심으로 Youtube Adwords, Facebook, SMR Wisdom, DMC 실집행 데이터를 일부 반영하여 구축된 예측 모델을 기반으로 도출되었습니다. <br />
          * 모델의 개선, 데이터 업데이트 등의 이슈로 인해 분석 시점마다 결과가 다소 상이할 수 있습니다. <br />
          * Budget -> Impression(GRPs)로 전환되는 비율은 기본적으로 CPM과 CPRP를 기준으로 합니다	<br />
          * 즉, 설정된 CPM 및 CPRP에 따라 기대되는 Impression(광고노출량)을 달성한다는 전제조건하의 예측결과입니다.
        <!-- </b-row> -->
      </div>
    </b-card>
    <b-card v-if="showResult" class="bs-callout bs-callout-primary panelScrollBar" style="height:100%;margin-bottom:12px;">
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:35px;">
          <b-col sm="9">
            <span class="card-title wise-card-title">Reach Curve Simulation Result</span>
          </b-col>
          <b-col sm="1">
            <div style="padding-top:10px">
              <b-button block variant="outline-success" class="btn-pill" @click="excelDown()">
                <span style="font-weight:900;">엑셀 다운</span>
              </b-button>
            </div>
          </b-col>
          <b-col sm="1">
            <div style="padding-top:10px">
              <b-button block variant="outline-primary" class="btn-pill" @click="confirmBtn()">
                <span style="font-weight:900;">확정 버튼</span>
              </b-button>
            </div>
          </b-col>
          <b-col sm="1"></b-col>
          <b-col sm="12">
            <component
            v-bind:resultListData="mediaResultList" v-bind:mediaResultDataList="mediaResultDataList"
            ref="resultListRef" v-for="(item, index) in componentsResultList"
            v-bind:index="index"
            v-bind:key="item.id" :is="item">
            </component>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import reachCurveFormData from "../common/ReachCurveFormData.js";
import Vue from 'vue';
import MediaTemplate from "./ScreenTemplate";
import ReachCurveResult from "./ReachCurveResult";

import leftSideUtil from "../common/LeftSideUtil.js"

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

const moment = require("moment");
import swal from 'sweetalert2';

export default {
  name: 'ReachCurveSimulation',
  components: {
    MediaTemplate,
    ReachCurveResult
  },
  data() {
    return {
      screens: reachCurveFormData.ScreenMediaStructure,
      mediaSize:1,
      historyData:{},
      formData: this.$_.clone(reachCurveFormData.formData),
      componentsMediaList: [],
      componentsResultList: [],
      mediaResultList:[],
      mediaResultDataList:[],
      advertigerModal: false,
      advertigerName: '',
      agencyModal: false,
      agencyName:'',
      search_avdt_nm: '',
      advertigerList: [],
      local_advertigerList: [],
      search_agc_nm: '',
      agencyList: [],
      local_agencyList: [],
      flagRootIndex:false,
      showResult:false,
    }
  },
  created: function() {
    // this.id = this._uid + "_";
    this.formData.mediaList = new Array(); // 주석달기
  },
  mounted: function() {
    leftSideUtil.highLightMenu('reachCurveCustomId8642');

    if (localStorage.local_advertigerList == null || localStorage.local_advertigerList == '') {} else {
      this.local_advertigerList = JSON.parse(localStorage.local_advertigerList);
    };
    if (localStorage.local_agencyList == null || localStorage.local_agencyList == '') {} else {
      this.local_agencyList = JSON.parse(localStorage.local_agencyList);
    };

    this.getScreenChannel('VA', 'TV');
    this.getScreenChannel('VA', 'PC');
    this.getScreenChannel('VA', 'Mobile');
    this.getScreenChannel('VA', 'Digital');
    this.getScreenChannel('DA', 'Digital')
    this.getScreenChannel('DA', 'PC');
    this.getScreenChannel('DA', 'Mobile');

    this.addMedia();
    this.changeRootIndex(1000);
  },
  methods: {
    getScreenChannel(type, media) {
      var user_id = this.$session.get('email');
      this.$http.get('/select/screenchannel?type=' + type + '&media=' + media)
        .then((result) => {
          // this.channelList = result.data;
          for(var i=0; i<result.data.length; i++){
              this.screens[type][media][result.data[i].channel] = [];
              this.$http.get('/select/screenvehicle?type=' + type + '&media=' + media + '&channel=' + result.data[i].channel + '&user_id='+user_id)
                .then((resultV) => {
                  this.screens[type][media][resultV.data[0].channel] = resultV.data;
                  // console.log(this.screens);
              })
          }
        })
    },
    goResult(){
      this.componentsResultList = []; // 이 함수 안에서는 안씀 . 기존 데이터 초기화를 위해서 있음
      this.mediaResultDataList = []; // 이 함수 안에서는 안씀 . 기존 데이터 초기화를 위해서 있음
      this.mediaResultList = [];

      // DA 모델의 채널에는 전체의 개념은 없음
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        if(this.formData.mediaList[key].channel == '전체' && this.formData.mediaList[key].media_type == 'DA'){
          swal({
            type: 'error',
            text: 'DA는 채널을 선택해야 합니다.'
          }).then((result) => {
            this.backtoForm();
          })
          return;
        }
      }

      this.showResult = false;
      var mediaRefLen = this.componentsMediaList.length;
      for (var i = 0; i < mediaRefLen; i++) {
        this.$refs.mediaListRef[i].validationFinish = false;
        this.$refs.mediaListRef[i].validateCheckFN();
      }

      this.$validator.validateAll().then(res => {
        if (res) {
          var self = this;

          setTimeout(function(){

            var finalResult = true;

            var keylistTmp = Object.keys(self.formData.mediaList);
            for (var i = 0; i < keylistTmp.length; i++) {
              var key = keylistTmp[i];
              finalResult = finalResult && self.formData.mediaList[key].formValidation;

              var minNumber = self.formData.mediaList[key].minNumber;
              var maxNumber = self.formData.mediaList[key].maxNumber;

              if((maxNumber-minNumber <14)){
                swal({
                  type: 'error',
                  title: "금액범위를 다시 입력해주세요.",
                  text:  "최대값과 최소값은 차이는 14이상이어야합니다."
                })
                finalResult = false;
              }else if(maxNumber < 0 || minNumber <0){
                swal({
                  type: 'error',
                  title: "금액범위를 다시 입력해주세요.",
                  text:  "음수는 입력할 수 없습니다."
                })
                finalResult = false;
              }else if(maxNumber > 150){
                swal({
                  type: 'error',
                  title: "금액범위를 다시 입력해주세요.",
                  text:  "최대값은 150을 넘을수 없습니다."
                })
                finalResult = false;
              }

            }

            if(finalResult){
              self.showResult = true;
              // var refLen = self.componentsResultList.length;
              // for (var i = 0; i < refLen; i++) {
              //   self.$refs.resultListRef[i].deleteThis();
              // }
              var keylist = Object.keys(self.formData.mediaList);
              for (var i = 0; i < keylist.length; i++) {
                var key = keylist[i];
                self.mediaResultList.push(self.formData.mediaList[key]);
                self.addResult();
              }
            }
          }, 1000);
        }
      });
    },
    findAdvertiger() {
      var param = "?advt_nm=" + this.search_avdt_nm;
      this.$http.get('/select/advertiger' + param)
        .then((result) => {
          this.advertigerList = result.data;
        })
    },
    selectedADVT(advt) {
      this.formData.advertiger = advt;
      this.advertigerName = advt.advt_NM;
      var push = true;
      // this.local_advertigerList = [];
      for (var i = 0; i < this.local_advertigerList.length; i++) {
        if (advt.advt_CD == this.local_advertigerList[i].advt_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_advertigerList.splice(0, 0, advt);
      }

      if (this.local_advertigerList.length > 15) {
        var cnt = this.local_advertigerList.length;
        this.local_advertigerList.splice(15, (cnt - 15));
      }

      localStorage.local_advertigerList = JSON.stringify(this.local_advertigerList);
      this.advertigerModal = false;
    },
    findAgency() {
      var param = "?agc_nm=" + this.search_agc_nm;
      this.$http.get('/select/agency' + param)
        .then((result) => {
          this.agencyList = result.data;
        })
    },
    selectedAGC(agc) {
      this.formData.agency = agc;
      this.agencyName = agc.agc_NM;
      var push = true;
      // this.local_advertigerList = [];
      for (var i = 0; i < this.local_agencyList.length; i++) {
        if (agc.agc_CD == this.local_agencyList[i].agc_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_agencyList.splice(0, 0, agc);
      }

      if (this.local_agencyList.length > 15) {
        var cnt = this.local_agencyList.length;
        this.local_agencyList.splice(15, (cnt - 15));
      }

      localStorage.local_agencyList = JSON.stringify(this.local_agencyList);
      this.agencyModal = false;
    },
    findIndustry() {
      this.$http.get('/select/industry')
        .then((result) => {
          this.industryList = result.data;
          this.formData.industry = this.industryList[0];
        })
    },
    addMedia() {
      //var child = this.makeMedia('MediaTemplate');
      this.componentsMediaList.push(this.makeMedia());
      var self = this;
    },
    changeRootIndex(second){
      // 매채 계획에 번호 부여하는 로직
      var self = this;
      setTimeout(function(){
        var keylist = Object.keys(self.formData.mediaList);
        self.mediaSize = keylist.length;
        for (var i = 0; i < keylist.length; i++) {
          var key = keylist[i];
          self.formData.mediaList[key].rootIndex = (i+1)
        }
        self.flagRootIndex = !self.flagRootIndex;
      }, second);
    },
    makeMedia() {
      return Vue.component('MediaTemplate', MediaTemplate);
    },
    addResult(){
      this.componentsResultList.push(this.makeResult());
    },
    makeResult(){
      return Vue.component('ReachCurveResult', ReachCurveResult);
    },
    excelDown(){
      var token = sessionStorage.getItem("myToken");
      var mediaResultList = JSON.stringify(this.mediaResultList);
      var mediaResultDataList = JSON.stringify(this.mediaResultDataList);

      var data = new FormData();
      data.append('resultList', mediaResultList);
      data.append('resultDataList', mediaResultDataList);
      // var param = '';
      var config = {
        responseType: 'blob'
      };

      this.$http.post('/excel/reachCurveResultDown',data,config)
        .then((result) => {
          // console.log(result);
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = this.formData.campaignTitle.replace(/ /gi, '');
          fileName = fileName + "_리치커브시뮬레이션_" + moment().format('YYYYMMDD') ;
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });

    },
    confirmBtn(){

      this.formData.mediaListResult = [];
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        this.formData.mediaListResult.push(this.formData.mediaList[key]);
      }

      this.historyData.user_id = this.$session.get('email');
      this.historyData.std_dt = moment().format('YYYY-MM-DD HH:mm');
      this.historyData.std_dm = moment().format('YYYY-MM');
      this.historyData.confirm_name = this.formData.campaignTitle;
      this.historyData.view_cd = 'reachCurveSimulation';
      this.historyData.view_name = '리치커브시뮬레이션';
      this.historyData.formData = JSON.stringify(this.formData);
      this.historyData.css = "primary";

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.historyData));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      var mediaRefLen = this.componentsMediaList.length;
      for (var i = 0; i < mediaRefLen; i++) {
        this.$refs.mediaListRef[i].validationFinish = false;
        this.$refs.mediaListRef[i].validateCheckFN();
      }

      this.$validator.validateAll().then(res => {
        if (res) {
          var self = this;

          setTimeout(function(){

            var finalResult = true;

            var keylistTmp = Object.keys(self.formData.mediaList);
            for (var i = 0; i < keylistTmp.length; i++) {
              var key = keylistTmp[i];
              finalResult = finalResult && self.formData.mediaList[key].formValidation;
            }

            if(finalResult){

              self.$http.post('/api/insert/confirmCampaign?access_token='+token, data,config)
                .then((result) => {
                  if(result.data == 'duplicate'){
                    swal({
                      type: 'error',
                      // title: 'Oops...',
                      text: "이번달에 저장된 확정안입니다."
                    })
                  }else if(result.data == 'ok'){
                    swal({
                      type: 'success',
                      // title: 'Oops...',
                      text: "확정안을 저장하였습니다."
                    })
                  }
              })
            }else{
              swal({
                type: 'error',
                // title: 'Oops...',
                text: "매체 계획을 확인하세요."
              })
            }
          }, 1000);
        }else{
          swal({
            type: 'error',
            // title: 'Oops...',
            text: "캠페인 기본 정보를 확인하세요."
          })
        }
      });




    }
  }
}
</script>

<style scoped>
input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
</style>



// WEBPACK FOOTER //
// src/views/reachCurve/ReachCurve.vue